import gql from 'graphql-tag';
import isNode from '../is-node';
import { CommonsMParticleOrderBundles } from '../rql';
import { ChildProps, graphql } from 'react-apollo';
import { mParticleListingFields } from './with_mparticle_listings';
import { browserHistory, RouteComponentProps } from 'react-router';
import { MParticleEventName, trackEvent } from '../elog/mparticle_tracker';
import { trackCriteoTransaction } from '../criteo';
import { useUser } from '../user_hooks';

type RouteProps = RouteComponentProps<{order_bundle_id: string}, {}>;
type IProps = RouteProps & ChildProps<RouteProps, CommonsMParticleOrderBundles.Query, CommonsMParticleOrderBundles.Variables>;

const TRACKING_COMPLETE_PARAM = 'mp_complete';

const graphQLConfig = {
  props: props => props,
  options: (props: RouteProps) => {
    return {
      variables: {
        id: props.params.order_bundle_id,
      },
      ssr: false,
      context: {
        headers: {
          // override user's currency, since all
          // mParticle tracking needs to be normalized to USD
          'X-Display-Currency': 'USD',
        },
      },
    };
  },
};

const ORDER_BUNDLES_QUERY = gql`
  query Commons_MParticle_OrderBundles(
    $id: String
  )
  {
    orderBundles(input: { ids: [$id] }) {
      _id
      paymentMethod
      localPickup
      amountTax {
        amount
      }
      amountShipping {
        amount
      }
      amountProductSubtotal {
        amount
      }
      orders {
        nodes {
          _id
          id
          quantity
          settlementAmountProductSubtotal {
            amount
          }
          listing {
            _id
            ...mParticleListingFields
          }
        }
      }
    }
  }
  ${mParticleListingFields}
`;

const TIMEOUT_LENGTH = 5000;

export function TrackMParticlePurchase(props: IProps, timeoutLength = TIMEOUT_LENGTH) {
  const user = useUser();

  if (isNode) return null;
  if (props.location.query[TRACKING_COMPLETE_PARAM] === 'true') return null;

  const { orderBundles } = props.data;

  if (orderBundles && orderBundles.length) {
    const orderBundle = orderBundles[0];
    trackEvent({
      orderBundle,
      eventName: MParticleEventName.Purchase,
    });

    trackCriteoTransaction(orderBundle, user);

    setTimeout(
      () => {
        browserHistory.replace({
          pathname: props.location.pathname,
          query: {
            ...props.location.query,
            [TRACKING_COMPLETE_PARAM]: true,
          },
        });
      },
      timeoutLength,
    );
  }

  return null;
}

export default graphql(ORDER_BUNDLES_QUERY, graphQLConfig)(TrackMParticlePurchase);
